import react, { useState } from 'react';
import { purple } from '@mui/material/colors';
import { BiLogoTypescript } from 'react-icons/bi';
import { FaAws, FaDocker, FaFacebookF, FaGithub, FaGoogle, FaInstagram, FaJava, FaLinkedin, FaPhp, FaPinterest, FaPython, FaReact, FaSwift } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { DiYahooSmall } from 'react-icons/di';
import { BsBing } from 'react-icons/bs';


 

  export const SocialMediaMarketing   = [
        
        { id: 1, name: 'LinkedIn', icon: <FaLinkedin  className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-linkedIn-animate' />
        },
        { id: 2, name: 'Facebook', icon:    <FaFacebookF className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-facebook-animate' /> },
        { id: 3, name: 'Instagram', icon:<FaInstagram  className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7] icon-Insta-animate' />
        },
        { id: 4, name: 'Twitter ', icon:<FaXTwitter    className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-twitter-animate' />
        },
        { id: 5, name: 'Pinterest ', icon: <FaPinterest    className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-pinterest-animate' />
        },
     
      
     
    
     
  ];
  export const   SearchEngineOptimization = [
     
        { id: 1, name: 'Google ', icon:<FaGoogle  className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-facebook-animate' /> },
        { id: 2, name: 'Bing ', icon:<BsBing   className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7] icon-Insta-animate' />
        },
        { id: 3, name: 'YahooSmall ', icon: <DiYahooSmall   className='text-6xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-linkedIn-animate' />
        },
       
     
      
     
    
     
  ];
  